import styles from './registration-email-form-header.module.scss'
import { useTranslation } from 'react-i18next'
import { DefaultEmailHeader } from '../default-email-header'

interface Props {}

export const RegistrationEmailFormHeader: React.FC<Props> = () => {
    const { t } = useTranslation()

    return (
        <>
            <DefaultEmailHeader
                titleKey={'registration.email_title'}
                subtitleKey={'registration.email_subtitle'} />
            <ul className={styles.tags}>
                <li className={styles.tag}>
                    <span>💻</span>
                    <span>
                        {t('registration.access_from_any_device')}
                    </span>
                </li>
                <li className={styles.tag}>
                    <span>🔐</span>
                    <span>
                        {t('registration.backup_login')}
                    </span>
                </li>
                <li className={styles.tag}>
                    <span>⚡</span>
                    <span>
                        {t('registration.quick_login_without_tg')}
                    </span>
                </li>
            </ul>
        </>
    )
}
